//errors
export const INVALID_TOKEN_MESSAGE = "Permission denied. Invalid token";
export const API_FAILURE_STATUS = "failure";

//short names superadmin
export const SUPERADMIN_COMPANIES_SHORT_NAME = "superadmin_companies";
export const SUPERADMIN_USERS_SHORT_NAME = "superadmin_users";
export const SUPERADMIN_CATEGORIES_SHORT_NAME = "superadmin_categories";
export const SUPERADMIN_TEMPLATES_SHORT_NAME = "superadmin_templates";

//short names orgAdmin
export const ORGADMIN_COMPANIES_SHORT_NAME = "companyadmin_company";
export const ORGADMIN_TEAM_SHORT_NAME = "companyadmin_team";
export const ORGADMIN_USERS_SHORT_NAME = "companyadmin_users";
export const ORGADMIN_CATEGORIES_SHORT_NAME = "companyadmin_categories";
export const ORGADMIN_NEWS_SHORT_NAME = "companyadmin_news";
export const ORGADMIN_EVENTS_SHORT_NAME = "companyadmin_events";
export const ORGADMIN_SUBSCRIBERS_SHORT_NAME = "companyadmin_subscribers";
export const ORGADMIN_MAILCHIMP_SHORT_NAME = "companyadmin_mailchimp";
export const ORGADMIN_WEDDING_SHORT_NAME = "companyadmin_wedding";
export const ORGADMIN_LANGUAGES_SHORT_NAME = "companyadmin_languages";
export const ORGADMIN_SEO_SHORT_NAME = "companyadmin_seo";
export const ORGADMIN_PROMOTIONS_SHORT_NAME = "companyadmin_promotions";
export const ORGADMIN_PODCASTS_SHORT_NAME = "companyadmin_podcasts";
export const ORGADMIN_POLICYBRIEFS_REPORTS_SHORT_NAME =
  "companyadmin_policybriefs_reports";

// export const attachment_URL = "http://attachments.stay.consulting";
export const attachment_URL = "https://attachments.csms.edu.lb";
// export const attachment_URL = "http://localhost/attachments";
export const rowsPerPage = 10;
// export const restUrl = "http://localhost/tronic-apis/api/v1/";
export const restUrl = "https://api.csms.edu.lb/api/v1/";
// export const restUrl = "https://api.electionslebanon.com/api/v1/";
